var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17448",
    fill: "#5e708d",
    stroke: "#707070",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1464",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17449",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    transform: "translate(.621 5.5)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21681",
    d: "M21.639 5.55C20.589 4.25 16.689 0 10.989 0S1.389 4.25.339 5.55a1.5 1.5 0 0 0 0 1.9c1.05 1.3 4.95 5.55 10.65 5.55s9.6-4.25 10.65-5.55a1.5 1.5 0 0 0 0-1.9ZM10.989 11c-4.4 0-7.65-3.1-8.85-4.5 1.2-1.4 4.45-4.5 8.85-4.5s7.65 3.1 8.85 4.5c-1.2 1.4-4.45 4.5-8.85 4.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 5959",
    cx: 3,
    cy: 3,
    transform: "translate(8.379 3.5)",
    r: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconWhite);
export default __webpack_public_path__ + "static/media/eye_icon_white.cf50f6424a6c90c264f5899fa8ab8db3.svg";
export { ForwardRef as ReactComponent };